import forge from 'node-forge'

/**
 * Extracts the expiration date from a PKCS12 certificate
 */
export const extractExpirationFromCert = (
  certBase64: string,
  password?: string,
): Date | null => {
  const decoded = forge.util.decode64(certBase64)
  const asn1 = forge.asn1.fromDer(decoded)
  const p12 = forge.pkcs12.pkcs12FromAsn1(asn1, password)
  const bags = p12.getBags({ bagType: forge.pki.oids.certBag })
  const certBag = bags[forge.pki.oids.certBag]?.[0]
  return certBag?.cert?.validity.notAfter || null
}
